import React, { Fragment } from 'react';
import { useLazyGetCrewDeliveryPdfQuery } from '../../../redux/api/crewDeliveryApi';
import PdfButton from '../../../components/pdf/PdfButton';

const CrewDeliveryPdfButtons = ({ deliveryId }) => {
  const [fetchPdf] = useLazyGetCrewDeliveryPdfQuery();
  const filename = `crew-delivery-${deliveryId.slice(0, 8)}.pdf`;

  return (
    <Fragment>
      <PdfButton
        onFetch={() => fetchPdf(deliveryId).unwrap()}
        filename={filename}
        label='Lieferschein (PDF)'
        variant='primary'
        size={null}
      />
      <PdfButton
        onFetch={() => fetchPdf(deliveryId).unwrap()}
        filename={filename}
        label='Lieferschein drucken'
        icon='print'
        action='print'
        variant='outline-primary'
        size={null}
        className='ms-2'
      />
    </Fragment>
  );
};

export default CrewDeliveryPdfButtons;
